<template>
  <div class="flex-view">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'FlexView',
}
</script>

<style lang="less">
.flex-view {
  height: 100% !important;
  flex: 1 1 0;

  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>